import { useEffect, useState } from 'react';
import { useRefreshingLoad } from './useRefreshingLoad';
import type { OwnProfile } from '../types/people';

// Photo links last an hour; this keeps a fresh one on screen.
const REFRESH_MS = 30 * 60_000;

/**
 * The signed-in person's own photo for the corner of the app, or null to show the settings gear:
 * before they have one, or if it fails to load. Reloads for another account and on coming back.
 */
export function useOwnPhoto(load: () => Promise<OwnProfile>, account: string) {
  const [tick, setTick] = useState(0);
  const [broken, setBroken] = useState<string | null>(null);
  useEffect(() => {
    const timer = setInterval(() => setTick((value) => value + 1), REFRESH_MS);
    return () => clearInterval(timer);
  }, []);
  const { data } = useRefreshingLoad(load, [account, tick]);
  const photoUrl = data?.photoUrl && data.photoUrl !== broken ? data.photoUrl : null;
  return { photoUrl, onError: () => setBroken(photoUrl) };
}
